import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetBooksQuery } from '../features/api/apiSlice';
import { filtered } from '../features/filters/filtersSlice';
import BookCard from './BookCard';

const Main = () => {
  const { data: books, isLoading, isError, error } = useGetBooksQuery();
  const { search, featured } = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <p>Loading...</p>;
  }
  if (!isLoading && isError) {
    content = <p>{error}</p>;
  }
  if (!isLoading && !isError && books?.length === 0) {
    content = <p>No books found!</p>;
  }

  let filteredBooks = books;

  if (search) {
    filteredBooks = filteredBooks.filter((book) =>
      book.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  if (featured) {
    filteredBooks = filteredBooks.filter((book) => book.featured);
  }

  if (!isLoading && !isError && books?.length > 0) {
    content = filteredBooks.map((book) => (
      <BookCard key={book.id} book={book} />
    ));
  }

  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <div className="flex items-center justify-between mb-12">
          <h4 className="mt-2 text-xl font-bold">Book List</h4>

          <div className="flex items-center space-x-4">
            <button
              className={`lws-filter-btn ${featured ? '' : 'active-filter'}`}
              onClick={() => dispatch(filtered(false))}
            >
              All
            </button>
            <button
              className={`lws-filter-btn ${featured ? 'active-filter' : ''}`}
              onClick={() => dispatch(filtered(true))}
            >
              Featured
            </button>
          </div>
        </div>
        <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
          {content}
        </div>
      </div>
    </main>
  );
};

export default Main;
